// extracted by mini-css-extract-plugin
module.exports = {"timeBox":"HoursMinutes_timeBox__3XX-F","container":"HoursMinutes_container__18Zwq","valid":"HoursMinutes_valid__35Uhu","invalid":"HoursMinutes_invalid__1xsH4"};